import Vue from 'vue'
import VueAxios from 'vue-axios'
import { axios } from '@/utils'

Vue.use(VueAxios, axios)
